export const List = () => import("./List.vue");
export const Destroy = () => import("./Destroy.vue");
export const Dispatch = () => import("./Dispatch.vue");
export const Received = () => import("./Received.vue");
export const MyLetters = () => import("./MyLetters.vue");
export const IndexSheet = () => import("./IndexSheet.vue");
export const MyOfficeLetters = () => import("./MyOfficeLetters.vue");
export const InstituteLetters = () => import("./InstituteLetters.vue");
export const InstituteLetterDetails = () => import("./InstituteLetterDetails.vue");
export const IncomingPendingLetters = () => import("./IncomingPendingLetters.vue");
export const OutgoingPendingLetters = () => import("./OutgoingPendingLetters.vue");
